import PokerTable from "../model/PokerTable";
import PokerPlayer from "../model/PokerPlayer";

export const cardShouldBeClickable = (table: PokerTable, player: PokerPlayer) => {
    return !table.hasCardsRevealed() || table.isChangeOpenCardEnabled() || player.playedCardValue === undefined
}
